"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconColorThemes = void 0;
var react_1 = __importStar(require("react"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var IconColorThemes;
(function (IconColorThemes) {
    IconColorThemes["uiDark1"] = "uiDark1";
    IconColorThemes["default"] = "default";
    IconColorThemes["white"] = "white";
})(IconColorThemes = exports.IconColorThemes || (exports.IconColorThemes = {}));
var Mail = function (_a) {
    var _b = _a.color, color = _b === void 0 ? IconColorThemes.default : _b, size = _a.size, rest = __rest(_a, ["color", "size"]);
    var _c = (0, react_1.useState)(b2c_theme_1.colors.defaultIconColor), iconColor = _c[0], setIconColor = _c[1];
    var _d = (0, react_1.useState)(b2c_theme_1.defaultIconSize), iconSize = _d[0], setIconSize = _d[1];
    (0, react_1.useEffect)(function () {
        switch (color) {
            case IconColorThemes.white:
                setIconColor(b2c_theme_1.colors.white);
                break;
            case IconColorThemes.uiDark1:
                setIconColor(b2c_theme_1.colors.iconUiDark1);
                break;
            default:
                setIconColor(b2c_theme_1.colors.defaultIconColor);
        }
    }, [color]);
    (0, react_1.useEffect)(function () {
        switch (size) {
            case b2c_theme_1.IconSizes.xSmall:
                setIconSize(b2c_theme_1.IconSizesPx.xSmall);
                break;
            case b2c_theme_1.IconSizes.small:
                setIconSize(b2c_theme_1.IconSizesPx.small);
                break;
            case b2c_theme_1.IconSizes.medium:
                setIconSize(b2c_theme_1.IconSizesPx.medium);
                break;
            case b2c_theme_1.IconSizes.large:
                setIconSize(b2c_theme_1.IconSizesPx.large);
                break;
            case b2c_theme_1.IconSizes.default:
                setIconSize(b2c_theme_1.defaultIconSize);
            default:
                setIconSize(b2c_theme_1.defaultIconSize);
        }
    }, [size]);
    var innerIcon = (0, react_1.useMemo)(function () {
        switch (iconSize) {
            case b2c_theme_1.IconSizesPx.xSmall:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("path", { "data-testid": "mail-icon", fillRule: "evenodd", clipRule: "evenodd", d: "M2.46908 0.5H13.5308C14.7717 0.5 15.7777 1.50598 15.7777 2.74691V11.142C15.7777 12.3829 14.7717 13.3889 13.5308 13.3889H2.46908C1.22815 13.3889 0.222168 12.3829 0.222168 11.142V2.74691C0.222168 1.50598 1.22815 0.5 2.46908 0.5ZM1.55874 2.66948C1.55659 2.69501 1.5555 2.72083 1.5555 2.74691V11.142C1.5555 11.6465 1.96453 12.0556 2.46908 12.0556H13.5308C14.0354 12.0556 14.4444 11.6465 14.4444 11.142V2.74691C14.4444 2.72085 14.4433 2.69504 14.4412 2.66953L7.99994 8.48457L1.55874 2.66948ZM2.62228 1.83333L7.99995 6.68827L13.3777 1.83333H2.62228Z", fill: iconColor })));
            case b2c_theme_1.IconSizesPx.small:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("path", { "data-testid": "mail-icon", fillRule: "evenodd", clipRule: "evenodd", d: "M2.46908 0.5H13.5308C14.7717 0.5 15.7777 1.50598 15.7777 2.74691V11.142C15.7777 12.3829 14.7717 13.3889 13.5308 13.3889H2.46908C1.22815 13.3889 0.222168 12.3829 0.222168 11.142V2.74691C0.222168 1.50598 1.22815 0.5 2.46908 0.5ZM1.55874 2.66948C1.55659 2.69501 1.5555 2.72083 1.5555 2.74691V11.142C1.5555 11.6465 1.96453 12.0556 2.46908 12.0556H13.5308C14.0354 12.0556 14.4444 11.6465 14.4444 11.142V2.74691C14.4444 2.72085 14.4433 2.69504 14.4412 2.66953L7.99994 8.48457L1.55874 2.66948ZM2.62228 1.83333L7.99995 6.68827L13.3777 1.83333H2.62228Z", fill: iconColor })));
            case b2c_theme_1.IconSizesPx.medium:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("path", { "data-testid": "mail-icon", fillRule: "evenodd", clipRule: "evenodd", d: "M2.46908 0.5H13.5308C14.7717 0.5 15.7777 1.50598 15.7777 2.74691V11.142C15.7777 12.3829 14.7717 13.3889 13.5308 13.3889H2.46908C1.22815 13.3889 0.222168 12.3829 0.222168 11.142V2.74691C0.222168 1.50598 1.22815 0.5 2.46908 0.5ZM1.55874 2.66948C1.55659 2.69501 1.5555 2.72083 1.5555 2.74691V11.142C1.5555 11.6465 1.96453 12.0556 2.46908 12.0556H13.5308C14.0354 12.0556 14.4444 11.6465 14.4444 11.142V2.74691C14.4444 2.72085 14.4433 2.69504 14.4412 2.66953L7.99994 8.48457L1.55874 2.66948ZM2.62228 1.83333L7.99995 6.68827L13.3777 1.83333H2.62228Z", fill: iconColor })));
            case b2c_theme_1.IconSizesPx.large:
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("path", { "data-testid": "mail-icon", fillRule: "evenodd", clipRule: "evenodd", d: "M2.46908 0.5H13.5308C14.7717 0.5 15.7777 1.50598 15.7777 2.74691V11.142C15.7777 12.3829 14.7717 13.3889 13.5308 13.3889H2.46908C1.22815 13.3889 0.222168 12.3829 0.222168 11.142V2.74691C0.222168 1.50598 1.22815 0.5 2.46908 0.5ZM1.55874 2.66948C1.55659 2.69501 1.5555 2.72083 1.5555 2.74691V11.142C1.5555 11.6465 1.96453 12.0556 2.46908 12.0556H13.5308C14.0354 12.0556 14.4444 11.6465 14.4444 11.142V2.74691C14.4444 2.72085 14.4433 2.69504 14.4412 2.66953L7.99994 8.48457L1.55874 2.66948ZM2.62228 1.83333L7.99995 6.68827L13.3777 1.83333H2.62228Z", fill: iconColor })));
        }
    }, [iconSize, iconColor]);
    return (react_1.default.createElement("svg", __assign({ width: 16, height: 14, viewBox: "0 0 16 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "mail-icon-container" }, rest), innerIcon));
};
exports.default = Mail;
//# sourceMappingURL=Mail.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Icons/Mail/Mail.js
// module id = 2445
// module chunks = 15